module.exports = __webpack_public_path__ + "media/images/notifications/icon_not_4-e8622bd7ce5d8b71f996b403b29c5d41.svg";